<template>
    <div class="container-fluid">
        <div class="contato row">
            <div class="contato-title col-md-12">
                <h1>Contacto</h1>
            </div>
            <div class="col-md-12">
              <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                  <div class="col-md-6" :style="{'float': 'left'}">
                      <b-form-group>
                          <b-form-input id="nomeInput"
                                      type="text"
                                      v-model="form.nome"
                                      required
                                      placeholder="Nombre">
                          </b-form-input>
                      </b-form-group>
                      <b-form-group>
                          <b-form-input id="emailInput"
                                      type="email"
                                      v-model="form.email"
                                      required
                                      placeholder="E-mail">
                          </b-form-input>
                      </b-form-group>
                      <b-form-group>
                          <b-form-input id="telefoneInput"
                                      type="text"
                                      v-model="form.telefone"
                                      required
                                      placeholder="teléfono">
                          </b-form-input>
                      </b-form-group>
                      <b-form-group>
                          <b-form-input id="assuntoInput"
                                      type="text"
                                      v-model="form.assunto"
                                      required
                                      placeholder="sujeto">
                          </b-form-input>
                      </b-form-group>
                  </div>
                  <div class="col-md-6" :style="{'float': 'left'}">
                      <b-form-textarea id="mensagemInput"
                          v-model="form.text"
                          placeholder="mensaje"
                          :rows="8"
                          :max-rows="8">
                      </b-form-textarea>
                  </div>
              </b-form>
            </div>
            <div class="col-md-6 endereco-item">
              <p>
                <span>Matriz</span><br>
                Indústria e Comércio de Bebidas Funada Ltda.<br>
                Av. Presidente Juscelino K. de Oliveira, 2587<br>
                B.Esquema | Cep: 19065-300 | Presidente Prudente - SP<br> 
                Fone:(18) 2101-2100 / Fax: 2101-2121<br>
              </p>
            </div>
            <div class="col-md-6 endereco-item">
              <p>
                <span>Filial</span><br>
                Indústria e Comércio de Bebidas Funada Ltda.<br>
                R. Principal 10, 434 | Núcleo Indústrial<br>
                Cep: 79108-552 | Campo Grande - MS<br>
                Fone/Fax:(67) 3391-2100<br>
              </p>
            </div>
            <div class="mapa col-md-12">
              <iframe width="100%" height="600" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3696.674788764097!2d-51.427482484482645!3d-22.100233485427964!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9493f6ae843d4a3f%3A0x9fdd3f305ed7bac7!2sFunada!5e0!3m2!1spt-BR!2sbr!4v1535463606572" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
              </iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        name: "",
        food: null
      },
      show: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style scoped>
.container-fluid {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 50px;
  background-color: #ededed;
}

.contato {
  font-family: "Bambino";
  text-transform: uppercase;
  background-color: #ededed;
}

.contato-title h1 {
  padding-left: 20px;
  padding-bottom: 20px;
  font-size: 10pt;
}

.form-control {
  font-family: "Bambino";
  text-transform: uppercase;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 13px 26px 38px 8px;
  font-size: 10px;
  line-height: 1.5;
  color: #000000;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

textarea.form-control {
  height: 262px;
}

.endereco-item {
  height: 100%;
  min-height: 100%;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  line-height: 18px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.endereco-item span {
  font-size: 13px;
  font-weight: 500;
}

.endereco-item p {
  font-size: 10px;
  font-weight: 400;
}

.mapa {
  margin: 0;
  padding: 0;
}

input[type="text"],
input[type="number"],
input[type="password"],
input[type="email"],
textarea {
  outline: none;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Contato.vue